function ManageBtnArea(props: any) {
  let myProps = {
    select_finish: (inData: any) => { },
    is_order_online: false,
    set_is_order_online: (inData: boolean) => { },
    is_req_order: true,
    ...props
  };

  return (
    <div style={{ position: "relative", textAlign: "right" }}>
      {(myProps.is_req_order&&false) &&
        <label>
          <input type="checkbox" checked={myProps.is_order_online}
            onChange={(e) => { 
              myProps.set_is_order_online(e.target.checked);
             }} />
          <span className="ml-1">온라인</span>
        </label>
      }
      <button className="btn btn-sky ml-1" onClick={() => { myProps.select_finish({}); }}>선택완료</button>
    </div>
  );
};
export default ManageBtnArea;